import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TransactionMediumFilter extends Component {
    state = {
        TransactionMediumList:[],
        TransactionMediumValue: null,
        TransactionMediumIds: '',
        isLoading: true
    };
    componentDidMount(){
        this.communication_id();
    }

    resetTransactionMediumFilter(){
        this.setState({
        TransactionMediumValue: [],
        })
    }
    communication_id(){
       axios.get(config.get('API_URL')+'/reports/communication_id/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((communication_id, index) => {
                    this.state.TransactionMediumList.push({value: communication_id.communication_id, label: communication_id.display_name})
                });
            }
        });
    }
    changeTransactionMedium(optionSelected){
        let value='';
        let commArray = [];
        if(optionSelected.length<1){
            value = null;
            commArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                commArray.push(mids.value);
                var index = this.state.TransactionMediumList.findIndex(obj => obj.value==mids.value);
                this.state.TransactionMediumList.move(index,0).join(',');
            });
        }
       this.props.onSelectTransactionMedium(optionSelected,commArray);
        this.setState({
            TransactionMediumValue:optionSelected,
        });
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="communication_id"
            isMulti
            value={this.state.TransactionMediumValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeTransactionMedium.bind(this)}
            options={this.state.TransactionMediumList}
            placeholderButtonLabel="Select [Transaction Medium]"
            />
        );

    }
}
export default TransactionMediumFilter;